import React, { useEffect, useState } from "react";
import { FaTrash } from "react-icons/fa";
import Loader from "../Loader";
import DeletePlanPackageConfirmationModal from "./DeletePlanPackageConfirmationModal";

const PartnerPlanPackagesModal = ({
  show,
  onClose,
  onDeleteClick,
  selectedPackage,
  showDeleteModal,
  setShowDeleteModal,
  handleDeletePackage,
  fetchPackages,
  packages,
  loading,
  isDeleting,
}) => {
  const [selectedPlanPackage, setSelectedPlanPackage] = useState(null);
  useEffect(() => {
    if (show && selectedPackage?.id) fetchPackages();
  }, [show, selectedPackage?.id]);

  if (!show) return null;

  return (
    <>
      <div className="modal fade show" style={{ display: "block" }}>
        <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <p className="modal-title fw-semibold">
                {selectedPackage?.plan_name}
              </p>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
              ></button>
            </div>
            <div className="modal-body">
              {loading ? (
                <div className="d-flex justify-content-center py-4">
                  <Loader />
                </div>
              ) : packages.length === 0 ? (
                <p>No {selectedPackage?.plan_name} packages available.</p>
              ) : (
                <table className="table table-tb">
                  <thead>
                    <tr className="rounded">
                      <th className="tr-tt fw-bold" scope="col">
                        #
                      </th>
                      <th className="tr-tt fw-bold" scope="col">
                        Package Name
                      </th>
                      <th className="tr-tt fw-bold" scope="col">
                        Discounted Price
                      </th>
                      <th className="tr-tt fw-bold" scope="col">
                        Selling Price
                      </th>
                      <th className="tr-tt fw-bold" scope="col">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {packages.map((pkg, index) => (
                      <tr key={pkg.id}>
                        <th className="align-middle position-relative">
                          {index + 1}
                        </th>
                        <th className="align-middle position-relative">
                          {pkg.packageName}
                        </th>
                        <th className="align-middle position-relative">
                          ${pkg.package_discounted_price}
                        </th>
                        <th className="align-middle position-relative">
                          ${pkg.package_selling_price}
                        </th>

                        <th className="align-middle position-relative">
                          <button
                            className="btn btn-sm btn-danger"
                            onClick={() => {
                              onDeleteClick(pkg);
                              setSelectedPlanPackage(pkg);
                            }}
                          >
                            <FaTrash />
                          </button>
                        </th>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>

      {/* Delete Confirmation Modal */}
      <DeletePlanPackageConfirmationModal
        show={showDeleteModal}
        onCancel={() => setShowDeleteModal(false)}
        onConfirm={() => handleDeletePackage(selectedPlanPackage?.id)}
        packageName={selectedPlanPackage?.packageName}
        isDeleting={isDeleting}
      />
    </>
  );
};

export default PartnerPlanPackagesModal;
